module.exports = __webpack_public_path__ + "static/volume-increase-e4783c1b7f96212671b5fe218bfadeca.svg";